import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload, faTrash } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx'; // For parsing Excel files

const AdminVisitInfo = () => {
  const [view, setView] = useState('current');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [file, setFile] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await axios.get('https://citi-mobile-app.onrender.com/admin/visit');
      setOrders(response.data);
      setLoading(false);
    } catch (error) {
      setError('Failed to fetch visits');
      setLoading(false);
    }
  };

  const handleFileUpload = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUploadSubmit = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    try {
      await axios.post('https://citi-mobile-app.onrender.com/admin/visit/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      fetchOrders(); // Refresh the table after successful upload
    } catch (error) {
      console.error('Error uploading file', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://citi-mobile-app.onrender.com/admin/visit/${id}`);
      fetchOrders(); // Refresh the table after deletion
    } catch (error) {
      console.error('Error deleting visit', error);
    }
  };

  return (
    <div className="max-w-[85%] mt-20 ml-60 max-sm:ml-0 max-sm:w-screen">

      <div className="overflow-x-auto p-3 rounded-md w-[100%] overflow-y-auto max-h-96 shadow-md bg-white">
        <h1 className="text-[#1E1E1E] font-bold mb-5 text-lg lg:text-xl">
          Customers Visit
        </h1>
        <table className="w-[100%]">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left">No</th>
              <th className="px-4 py-2 text-left">Customer Name</th>
              <th className="px-4 py-2 text-left">Sales Agent</th>
              <th className="px-4 py-2 text-left">Visit Days</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {orders.map((order, index) => (
              <tr key={order._id} className="border-b">
                <td className="px-4 py-2">{index + 1}</td>
                <td className="px-4 py-2">{order.firstName} {order.lastName}</td>
                <td className="px-4 py-2">{order.fieldagent}</td>
                <td className="px-4 py-2">{order.customervisitdays}</td>
                <td className="px-4 py-2">
                  {/* <button
                    className="text-red-600"
                    onClick={() => handleDelete(order._id)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminVisitInfo;